import api from './service'


export const getLoans = (params) => api(`/auth/getloans`, params)
export const createNewApplication = (data) => api(`/auth/createnewapplication`, data,'post')
export const Switch = (data) => api(`/auth/switch`, data,'post')
export const CheckSignInMethod = (data) => api(`/auth/checksigninmethod`, data,'post')
export const checkCustomerInfo = (header) => api(`/data/companycustomization`, {},'get',header)
export const SetUpOrChangePassword = (data) => api(`/auth/setuporchangepassword`, data,'post')